import React from 'react';
import { Input } from 'antd';
import { VOICE_PROVIDERS } from '../constants';

interface VoiceProviderInputProps {
	provider: keyof typeof VOICE_PROVIDERS;
	value: number;
	onChange: (value: number) => void;
}

const VoiceProviderInput: React.FC<VoiceProviderInputProps> = ({ provider, value, onChange }) => {
	const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
		const newValue = parseFloat(e.target.value) || 0;
		onChange(newValue);
	};

	return (
		<div>
			<label className="block text-xs font-medium text-gray-600 mb-1">
				{VOICE_PROVIDERS[provider]}
			</label>
			<Input
				type="number"
				step="0.01"
				min="0"
				value={value}
				onChange={handleChange}
				className="w-full"
			/>
		</div>
	);
};

export default VoiceProviderInput;
